import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from 'vuex';
import { required, email, numeric, minLength } from 'vuelidate/lib/validators';
import { emailErrorMessagesMixin, lettersAndNumbersMixin, onlyNumbersMixin, onlyLettersMixin } from '~/mixins';
import { onlyLetters, onlyEmail } from '~/validators';
import { ConflictError, BadRequestError } from '~/abstractions/errors';
import loader from "../modals/loader";

export default {
  mixins: [emailErrorMessagesMixin, lettersAndNumbersMixin, onlyNumbersMixin, onlyLettersMixin],
  data: function data() {
    var _$store$state$master = this.$store.state['master-data'],
        documentTypesCollaboratorsPage = _$store$state$master.documentTypesCollaboratorsPage,
        userCategories = _$store$state$master.userCategories;

    return {
      modalTitle: "Cargar lista de vendedores",
      teamIsActive: true,
      dialog: false,
      files: [],
      loading: false,
      errors: 0
    };
  },

  components: {
    loader: loader
  },
  methods: {
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
    },
    downloadModelSeller: function downloadModelSeller() {
      this.$store.dispatch("collaborators/teams/downloadChargeSeller");
    },
    registerUpload: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('registerFile', file);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function registerUpload(_x) {
        return _ref.apply(this, arguments);
      }

      return registerUpload;
    }(),
    cancel: function cancel() {
      this.$router.go();
      this.$v.$reset();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-charge-seller-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-charge-seller-modal.vue
// module chunks = 4